/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tag: NonNullable<unknown> }} Form_Tags_RemoveInputs */

const cs_form_tags_remove = /** @type {(inputs: Form_Tags_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Odstranit štítek ${i?.tag}`)
};

const en_form_tags_remove = /** @type {(inputs: Form_Tags_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove tag ${i?.tag}`)
};

/**
* | output |
* | --- |
* | "Remove tag {tag}" |
*
* @param {Form_Tags_RemoveInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_tags_remove = /** @type {((inputs: Form_Tags_RemoveInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Tags_RemoveInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_tags_remove(inputs)
	return cs_form_tags_remove(inputs)
});